const AMOUNT_PATTERN = /^(-?)(\d+)(?:\.(\d{1,4}))?$/;
const FRACTION_DIGITS = 4;

/** Exact integer ten-thousandths of a decimal string with up to four places, else null. */
export const parseTenThousandths = (amount: string): bigint | null => {
    const match = AMOUNT_PATTERN.exec(amount);
    if (!match) {
        return null;
    }
    const [, sign, whole, fraction = ''] = match;
    return BigInt(`${sign}${whole}${fraction.padEnd(FRACTION_DIGITS, '0')}`);
};

export const formatTenThousandths = (tenThousandths: bigint): string => {
    const negative = tenThousandths < 0n;
    const digits = (negative ? -tenThousandths : tenThousandths).toString().padStart(FRACTION_DIGITS + 1, '0');
    return `${negative ? '-' : ''}${digits.slice(0, -FRACTION_DIGITS)}.${digits.slice(-FRACTION_DIGITS)}`;
};

/** Exact line total as a four-place string; empty when either operand is not a valid amount. */
export const multiplyMoney = (amount: string, quantity: number): string => {
    const tenThousandths = parseTenThousandths(amount);
    return tenThousandths === null || !Number.isInteger(quantity)
        ? ''
        : formatTenThousandths(tenThousandths * BigInt(quantity));
};

/** Exact sum as a four-place string; empty when any operand is not a valid amount. */
export const sumMoney = (amounts: readonly string[]): string => {
    let total = 0n;
    for (const amount of amounts) {
        const tenThousandths = parseTenThousandths(amount);
        if (tenThousandths === null) {
            return '';
        }
        total += tenThousandths;
    }
    return formatTenThousandths(total);
};
